import React, { Component, PropTypes } from 'react';
import { deduplicateByKey } from 'dna-core/components/utils/js/value';

export default class ValidationMessage extends Component {
	static propTypes = {
		errors: PropTypes.array.isRequired,
		wrapperClass: PropTypes.string,
		intl: PropTypes.object
	};
	static defaultProps = {
		errors: []
	};
	getErrors() {
		const { errors, intl } = this.props;
		const nonEmptyErrors = errors.filter(error=> !!error);
		const formattedErrors = nonEmptyErrors.map(error=> ({
			key: error.key,
			message: (intl) ? intl.formatMessage(error.key, error.messageTemplateValues) : error.message
		}));

		const uniquelyKeyedErrors = deduplicateByKey(formattedErrors, 'key');
		return deduplicateByKey(uniquelyKeyedErrors, 'message')
			.map(error => {
				return (
					<li data-qa="validationErrors"
						className="dna-input-validation-error"
						key={error.key}>
						{ error.message }
					</li>
				);
			});
	}
	render() {
		const { wrapperClass } = this.props;
		return (
			<div className={`dna-input-validation ${wrapperClass ? wrapperClass : ''}`}>
				<ul>
					{ ::this.getErrors() }
				</ul>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-form/components/validation-message/ValidationMessage.jsx